import "./Lumina.css";
import "./Gallery.css";
import GalleryItem from "./Gallery";

const GCS_BASE_URL = "https://storage.googleapis.com/portfolio-media-circus";

const title = "LUMINA (work in progress)";

function Lumina() {
  return (
    <>
      <section className="lumina">
        <div>
          <h1>{title}</h1>
          <div className="projects-grid">
            <div className="flexbox-item">
              <GalleryItem
                fileName={"lumina-process-image-esp32.png"}
                alt="Lumina work in progress ESP32 mini controller lab"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div>
            <div className="flexbox-item">
              <div
                style={{ overflow: "hidden", width: "100%", height: "100%" }}
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{
                    width: "100%",
                    height: "80%",
                    objectFit: "cover",
                    objectPosition: "center 30%",
                  }}
                >
                  <source
                    src={`${GCS_BASE_URL}/lumina-process-video%20(1).mp4`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
          <p>
            What happens to human rhythm and life when the digital world sets
            the tempo? Juggling and acrobatics are both ancient art forms built
            on bodies, risk, trust and live presence. What happens to a physical
            craft when AI and digital renderings can imitate everything, except
            real risk? Is it possible to stay present when algorithms shape the
            rhythm of our lives?
            <br></br>
            <br></br>
            Lumina is a project where traditional juggling meet modern stage
            technology. Together with software developers I am prototyping a
            performance bridge based on esp32 that tracks impact from circus
            props and translate it to a visual feedback that can be projected on
            to the stage.
            <br></br>
            <br></br>
            This work is currently being developed in collaboration with Bunker
            productions in Malmö.
          </p>
        </div>
      </section>
    </>
  );
}

export default Lumina;
